import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const Cursor = () => {
  const [label, setLabel] = useState(null);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.4 });

  useEffect(() => {
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) => {
      const t = e.target.closest("[data-cursor]");
      setLabel(t ? t.getAttribute("data-cursor") : null);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  return (
    <>
      <motion.div className="cursor-dot" style={{ x: sx, y: sy }} aria-hidden>
        <motion.div
          animate={{ scale: label ? 0.4 : 1 }}
          className="w-3 h-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white"
        />
      </motion.div>
      <motion.div className="cursor-label" style={{ x: sx, y: sy }} aria-hidden>
        {label && (
          <motion.span
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="block -translate-x-1/2 translate-y-4 whitespace-nowrap rounded-full bg-ember px-4 py-2 font-display text-[10px] font-bold uppercase tracking-[0.25em] text-ink"
          >
            {label}
          </motion.span>
        )}
      </motion.div>
    </>
  );
};

export default Cursor;
